import {
  STATUS,
  LOAD_FOLLOWED_ARTISTS_FAILURE,
  LOAD_FOLLOWED_ARTISTS_SUCCESS,
  LOAD_FOLLOWED_ARTISTS_REQUEST,
  UPDATE_FOLLOWING_SUCCESS,
} from '../actionTypes';
import type {StatusType} from './typings';

const initialState: ArtistsFollowedReducerProps = {
  status: STATUS.IDLE,
  data: [],
  error: null,
};

const toggleFollowing = (
  followingArray: string[],
  artistSlug: string,
  interested: boolean,
): string[] => {
  if (interested && !followingArray.includes(artistSlug)) {
    return [...followingArray, artistSlug];
  } else if (!interested && followingArray.includes(artistSlug)) {
    return followingArray.filter((slug) => slug !== artistSlug);
  } else {
    return [...followingArray];
  }
};

const artistsFollowedReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_FOLLOWED_ARTISTS_REQUEST:
      return {
        ...state,
        status: STATUS.LOADING,
        error: null,
      };
    case LOAD_FOLLOWED_ARTISTS_SUCCESS:
      return {
        ...state,
        status: STATUS.SUCCEEDED,
        data: action.response.data,
      };
    case LOAD_FOLLOWED_ARTISTS_FAILURE:
      return {
        ...state,
        status: STATUS.FAILED,
        error: action.error.message,
      };
    case UPDATE_FOLLOWING_SUCCESS:
      console.log('>>>', action);
      return {
        ...state,
        data: toggleFollowing(state.data, action.artistSlug, action.interested),
      };
    default:
      return {...state};
  }
};

export default artistsFollowedReducer;

export const selectFollowedState = (state) => state.artistsFollowed;

interface ArtistsFollowedReducerProps {
  status: StatusType;
  data: string[];
  error: null | string;
}
